import { render, staticRenderFns } from "./subCategoryList.vue?vue&type=template&id=33628460&"
import script from "./subCategoryList.vue?vue&type=script&lang=js&"
export * from "./subCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports